import * as z from "zod";

export const getPayPalAuthUrl = {
  name: "getPayPalAuthUrl" as const,
  input: z.object({}),
  output: z.object({ authorizationUrl: z.string() }),
};
